import Vue from "vue"


import 'moment/dist/locale/de'
import moment from 'moment/dist/moment'

import VueMoment from 'vue-moment'

Vue.use(VueMoment, { moment })
moment.locale("de")

export default moment
